import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { Auth2Service } from '../../auth/auth2.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [FaIconComponent]
})
export class HeaderComponent {
  readonly #auth2Service = inject(Auth2Service);

  readonly user = toSignal(this.#auth2Service.user());

  logout() {
    this.#auth2Service.logout();
  }
}
